// Import model
import { FilterRoomRequest } from '../models/FilterRoomRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { RoomCondition } from '../models/RoomCondition';
import { RoomFields } from '../models/RoomFields';
import { RoomIndexedFields } from '../models/RoomIndexedFields';

// Import dependency serializers (for complex types)
import { RoomConditionSerializer } from './RoomConditionSerializer';
import { RoomFieldsSerializer } from './RoomFieldsSerializer';
import { RoomIndexedFieldsSerializer } from './RoomIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterRoomRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterRoomRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterRoomRequest instance
   */
  static deserialize(json: string): FilterRoomRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterRoomRequest instance
   */
  static fromObject(obj: any): FilterRoomRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterRoomRequest');
    }


    const instance: FilterRoomRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as RoomIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as RoomFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        RoomConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterRoomRequest instances
   */
  static deserializeArray(json: string): FilterRoomRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterRoomRequest instance to a JSON string
   */
  static serialize(instance: FilterRoomRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterRoomRequest instance to a plain object
   */
  static toObject(instance: FilterRoomRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        RoomConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterRoomRequest instances to a JSON string
   */
  static serializeArray(instances: FilterRoomRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
